import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { routeMap, RouteName } from 'src/app/app.settings';

@Injectable({
  providedIn: 'root',
})
export class BusinessTypeService {
  private isB2BTypeSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isB2CTypeSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isB2BType$(): BehaviorSubject<boolean> {
    return this.isB2BTypeSubject$;
  }

  get isB2CType$(): BehaviorSubject<boolean> {
    return this.isB2CTypeSubject$;
  }

  constructor() {}

  public updateBusinessType(): void {
    this.isB2BTypeSubject$.next(this.isRouteInPathname(RouteName.smeQuote));
    this.isB2CTypeSubject$.next(this.isRouteInPathname(RouteName.simulator));
  }

  private isRouteInPathname(routeName: RouteName): boolean {
    return routeMap.find((el) => el.name === routeName).regex.test(window.location.pathname);
  }
}
